// extracted by mini-css-extract-plugin
export default {"subRenAndCancel":"subscription_subRenAndCancel__rR9ax"};